import script from "./ComplexInstructions.vue?vue&type=script&setup=true&lang=js"
export * from "./ComplexInstructions.vue?vue&type=script&setup=true&lang=js"

import "./ComplexInstructions.vue?vue&type=style&index=0&id=79266009&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/tests-frontend/tests-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79266009"]])

export default __exports__